import {useTranslation, Trans} from 'react-i18next';
import {Typography} from '@mui/material';
import {Modal, ModalProps} from '../../../../../../../components/modal/modal';
import {translations} from '../../../../../../../i18n/translations';
import './pending-tasks-modal.scss';

interface PendingTaskModalProps extends Omit<ModalProps, 'actions'> {
  onClose: () => void;
  onValidate: () => void;
}

export const PendingTaskModal = ({onClose, onValidate}: PendingTaskModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="pending-tasks-modal"
      preventCloseClick
      actions={[
        {
          label: t(translations.office.generics.cancel),
          type: 'destructive',
          onClick: onClose,
        },
        {
          label: t(translations.office.pending_tasks.modal_validate),
          type: 'nondestructive',
          onClick: onValidate,
        },
      ]}
    >
      <Trans>
        <Typography className="title-attention">
          {t(translations.office.pending_tasks.modal_task_validation_title)}
        </Typography>
      </Trans>
    </Modal>
  );
};
